import { render, staticRenderFns } from "./OverviewCurrentRound.vue?vue&type=template&id=e09f7350&scoped=true&"
import script from "./OverviewCurrentRound.vue?vue&type=script&lang=js&"
export * from "./OverviewCurrentRound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e09f7350",
  null
  
)

export default component.exports